// extracted by mini-css-extract-plugin
export var author = "layout-glossary-module--author--7b5cf";
export var category = "layout-glossary-module--category--18889";
export var header = "layout-glossary-module--header--12680";
export var headline = "layout-glossary-module--headline--1f5ee";
export var headlinePost = "layout-glossary-module--headline-post--5dc0d";
export var main = "layout-glossary-module--main--e013b";
export var paragraph = "layout-glossary-module--paragraph--17882";